import { render } from "./tipsThree.vue?vue&type=template&id=880218aa"
import script from "./tipsThree.vue?vue&type=script&lang=js"
export * from "./tipsThree.vue?vue&type=script&lang=js"

import "./tipsThree.vue?vue&type=style&index=0&id=880218aa&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__